export const NAME_MAX_LENGTH = 100;
export const EMAIL_MAX_LENGTH = 254;
export const PHONE_MAX_LENGTH = 20;
export const COUNTRY_MAX_LENGTH = 100;
export const PHONE_REGEX = /^\+?[1-9]\d{7,14}$/;

export const toAsciiDigits = (value) => String(value || '')
  .replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - 1632))
  .replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - 1776));

export const normalizePhoneNumber = (value) => toAsciiDigits(value).replace(/[\s()-]/g, '');

export const getFieldLengthValue = (value) => {
  const length = Number(value);
  return Number.isFinite(length) && length >= 0 ? Math.trunc(length) : null;
};

export const getAdditionalFieldHelperText = (field, errorText) => {
  if (errorText) return errorText;
  return '';
};
